import { uniq } from 'lodash';

import { NewsAndEventsModel } from '../interface/news-and-events';

export function generateDatesASC(newsAndEventsContent: NewsAndEventsModel[]) {
  return uniq(
    newsAndEventsContent.map((newsItem) => newsItem.attributes.year_posted)
  )
    .sort()
    .reverse();
}
